import {
    getBreadCrumbList,
    getLockInfoFromLocalstorage,
    getMenuByRouter,
    getTagNavListFromLocalstorage,
    setLockInfoInLocalstorage,
    setTagNavListInLocalstorage,
} from './app.service';
import routers from '@/router/routers';

export default {
    namespaced: true,
    state: {
        breadCrumbList: [],
        tagNavList: getTagNavListFromLocalstorage(),
        lockInfo: getLockInfoFromLocalstorage(),
    },
    getters: {
        menuList: (state, getters, rootState) =>
            getMenuByRouter(routers, rootState.user.access.filter(u => u.routerName !== null && u.routerName !== '')),
    },
    mutations: {
        setBreadCrumb(state, routeMetched) {
            state.breadCrumbList = getBreadCrumbList(routeMetched);
        },
        removeTag(state, list) {
            state.tagNavList = state.tagNavList.filter(item => !list.includes(item));
            setTagNavListInLocalstorage([...state.tagNavList]);
        },
        addTag(state, { name, path, meta }) {
            state.tagNavList.push({ name, path, meta });
            setTagNavListInLocalstorage([...state.tagNavList]);
        },
        setLockInfo(state, lockInfo) {
            state.lockInfo = lockInfo;
            setLockInfoInLocalstorage(lockInfo);
        },
    },
};
